import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Select } from "antd";
import H3FormInput from "@Uilib/h3FormInput";
import H3Text from "@Uilib/h3Text";
import SellerActions from "@Actions/sellerActions";
import UserActions from "@Actions/userActions";
import H3Button, { defaultButtonTypes } from "@Uilib/h3Button";
import { CountryCodes } from "@Apis/constants";
import Helpers from "@Apis/helpers";
import "./style.scss";
import PRZSelect from "../../../Common/UI/PRZSelect";

const { Option } = Select;

const UserProfile = ({
  getRoles,
  user,
  updateMyUser,
  getUserProfile,
  updateUserLoading,
  editPermission,
}) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [sideMenuBarType, setSideMenuBarType] = useState("FIXED");

  useEffect(() => {
    getRoles(user?.tenant_info?.tenant_id);

    if (user) {
      setName(user?.first_name);
      setEmail(user?.email);
      setPhone(user?.mobile);
      setCountryCode(user?.dial_code.toString());
      setRoleId(user?.tenant_info?.tenant_role_id);
      setSideMenuBarType(user?.side_menu_bar_type);
    }
  }, []);

  const addUser = () => {
    setFormSubmitted(true);

    if (
      Helpers.validateEmail(email) &&
      name &&
      Helpers.validatePhoneNumber(phone)
    ) {
      const payload = {
        email,
        first_name: name,
        dial_code: countryCode,
        mobile: phone?.toString(),
        tenant_id: user?.tenant_info?.tenant_id,
        tenant_role_id: roleId,
        user_id: user?.tenant_info?.user_id,
        side_menu_bar_type: sideMenuBarType,
      };
      updateMyUser(payload, () => getUserProfile());
    }
  };

  const countryOptions = CountryCodes?.map((item) => ({
    value: item?.dial_code,
    label: `${item?.flag} +${item?.dial_code}`,
  }));

  const sidebarOptions = [
    { label: 'Fixed', value: 'FIXED' },
    { label: 'Collapsible', value: 'COLLAPSIBLE' },
    // { label: 'Hover', value: 'HOVER' }, // excluded as commented
  ];

  return (
    <div className="form__wrapper" style={{paddingTop: "0px"}}>
      <div className="ant-row">
        <div className="ant-col-md-24">
          <div className="form__section">
            {/* <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
              <div className="form__section-line" />
            </div> */}
            <div className="form__section-inputs">
              <div className="ant-row">
                <div className="ant-col-md-8 ant-col-xs-24">
                  <div className="form__input-row">
                    <H3Text
                      text="Name"
                      className="form__input-row__label"
                      required
                    />
                    <H3FormInput
                      name="Name"
                      type="text"
                      containerClassName={`orgInputContainer form__input-row__input ${(formSubmitted && !name) ? 'form__input-row__input-error' : ''}`}
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(event) => setName(event.target.value)}
                      value={name}
                      required
                      disabled={updateUserLoading}
                      showError={formSubmitted && !name}
                      maxlength="50"
                    />
                  </div>
                </div>
                <div className="ant-col-md-8 ant-col-xs-24">
                  <div className="form__input-row">
                    <H3Text
                      text="Email"
                      className="form__input-row__label"
                      required
                    />
                    <H3FormInput
                      name="a valid email"
                      type="text"
                      containerClassName={`orgInputContainer form__input-row__input ${(formSubmitted && !email) ? 'form__input-row__input-error' : ''}`}
                      labelClassName="orgFormLabel"
                      inputClassName="orgFormInput"
                      placeholder=""
                      onChange={(event) => setEmail(event.target.value)}
                      value={email}
                      required
                      disabled={true || updateUserLoading}
                      showError={formSubmitted && !Helpers.validateEmail(email)}
                    />
                  </div>  
                </div>
                <div className="ant-col-md-8 ant-col-xs-24">
                  <div className="form__input-row">
                    <H3Text text="Phone" required className="form__input-row__label" />
                    <div
                      className="orgInputContainer flex-display"
                    >
                      <div className="phone-number__country-code">
                        <PRZSelect
                          value={countryCode}
                          showSearch
                          filterOption={(input, option) => {
                            const { label } = option.props;
                            const { value } = option.props;
                            return (
                              label.toLowerCase().includes(input.toLowerCase()) ||
                              value.toLowerCase().includes(input.toLowerCase())
                            );
                          }}
                          onChange={(value) => setCountryCode(value)}
                          className={formSubmitted && !countryCode ? 'prz-select__error-border' : ''}
                          style={{
                            borderRight: "1px solid lightgrey",
                            height: "28px",
                            width: "135px",
                            fontSize: "13px",
                            background: '#efefef',
                          }}
                          disabled={updateUserLoading || !editPermission}
                          options={countryOptions}
                        />
                      </div>
                      <H3FormInput
                        name="a valid phone number"
                        type="text"
                        labelClassName="orgFormLabel"
                        inputClassName="orgFormInput phone-number__input-box"
                        containerClassName={`orgInputContainer phone-number__input ${(formSubmitted && !phone) ? 'form__input-row__input-error' : ''}`}
                        placeholder=""
                        onChange={(event) =>
                          setPhone(event.target.value.replace(/\D/g, ""))
                        }
                        value={phone}
                        disabled={updateUserLoading || !editPermission}
                        maxlength="50"
                      />
                    </div>
                    {formSubmitted && !Helpers.validatePhoneNumber(phone) && (
                      <div className="input-error">
                        *Please enter valid phone number
                      </div>
                    )}
                  </div>
                </div>
              </div>
            
            </div>
          </div>

          <div className="form__section">
            <div className="flex-display flex-align-c mg-bottom-5 pd-right-15">
              <H3Text text="UI Settings" className="form__section-title" />
              <div className="form__section-line" />
            </div>
            <div className="form__section-inputs">
              <div className="ant-col-md-8 ant-col-xs-24">
                <div className="form__input-row">
                  <H3Text text="Side Menu Type" required className="form__input-row__label" />
                  <div className="orgInputContainer form__input-row__input borderless-select">
                    <PRZSelect
                      showSearch
                      placeholder="Select a menu type"
                      optionFilterProp="children"
                      onChange={(value) => setSideMenuBarType(value)}
                      value={sideMenuBarType}
                      disabled={updateUserLoading || !editPermission}
                      filterOption={(input, option) =>
                        option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                        0
                      }
                      style={{
                        border: !(formSubmitted && !sideMenuBarType)
                          ? "1px solid rgba(68, 130, 218, 0.2)"
                          : "1px solid red",
                      }}
                    options={sidebarOptions}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
                 
        <div className="update-user-profile__footer">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Update Profile"
            onClick={() => addUser()}
            isLoading={updateUserLoading}
            disabled={updateUserLoading}
            style={{
              width: "200px",
              padding: "7px 0px",
              marginLeft: "0",
            }}
          />
        </div>
      </div>
      </div>
    </div>  
  );
};

const mapStateToProps = ({ UserReducers, TenantReducers, PayoutReducers }) => ({
  user: UserReducers.user,
  tenants: TenantReducers.tenants,
  roles: UserReducers.roles,
  updateUserLoading: UserReducers.updateUserLoading,
  createConnectSessionLoading: PayoutReducers.createConnectSessionLoading,
  environment: UserReducers.environment,
});

const mapDispatchToProps = (dispatch) => ({
  setCityState: (city, state) =>
    dispatch(SellerActions.setCityState(city, state)),
  getCityState: (pincode) => dispatch(SellerActions.getCityState(pincode)),
  getRoles: (page) => dispatch(UserActions.getRoles(page)),
  updateMyUser: (payload, callback) =>
    dispatch(UserActions.updateMyUser(payload, callback)),
  getUserProfile: () => dispatch(UserActions.getUserProfile()),
  createConnectSession: (payload, callback) =>
    dispatch(PayoutActions.createConnectSession(payload, callback)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserProfile));
